import React, { useEffect, useState } from 'react';
import fetchHook from '../../../../hooks/fetchMSSQL-hook';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { Config } from './MachineTaskConstants';
import { fromApiResponse, getTaskName, getStatusBadge, formatTaskValue } from './Task';
import moment from 'moment';

export default function CyclicMachineTask() {
  const { fetchMssqlApi } = fetchHook();
  const [tasks, setTasks] = useState([]);
  const { machineId } = useParams();

  const getTasks = () => {
    fetchMssqlApi(`machine-tasks/cyclic/${machineId}`, { method: 'GET' }, data => {
      const taskInstances = data.map(apiTask => fromApiResponse(apiTask));
      setTasks(taskInstances.filter(task => task.reccuringEvery > 0));
    }, error => {
      console.error(error);
    });
  };

  useEffect(() => {
    getTasks();
  }, []);

  const cancelTask = (taskId) => {
    fetchMssqlApi(`machine-tasks/${taskId}`, { method: 'PUT' }, () => getTasks());
  };

  const parseDatetime = (datetime) => {
    if (!datetime) return '';
    return moment.utc(datetime).local().format('YYYY-MM-DD HH:mm:ss');
  };

  const commandsMap = new Map(Config && Config.map(i => [i.taskType, i.name]));

  const getExecutionDetails = (task) => {
    if (!task.reccuringEvery || task.reccuringEvery <= 0) return null;

    const now = moment();
    const start = task.startAt ? moment.utc(task.startAt).local() : null;
    const end = task.endAt ? moment.utc(task.endAt).local() : null;
    const last = task.lastStartDateTime ? moment.utc(task.lastStartDateTime).local() : null;
    const created = task.createDateTime ? moment.utc(task.createDateTime).local() : null;

    let firstOrNextText = null;
    let isFutureStart = false;

    if (start && start.isAfter(now)) {
      firstOrNextText = start.format('YYYY-MM-DD HH:mm:ss');
      isFutureStart = true;
    } else if (last) {
      const next = last.clone().add(task.reccuringEvery, 'seconds');
      firstOrNextText = next.format('YYYY-MM-DD HH:mm:ss');
    } else if (start) {
      firstOrNextText = start.format('YYYY-MM-DD HH:mm:ss');
    }

    let lastCycleRunText = null;
    if (end) {
      const baseTime = start || created || now;
      if (end.isAfter(baseTime)) {
        const diffSec = end.diff(baseTime, 'seconds');
        const cycles = Math.floor(diffSec / task.reccuringEvery);
        const lastRun = baseTime.clone().add(cycles * task.reccuringEvery, 'seconds');
        lastCycleRunText = lastRun.format('YYYY-MM-DD HH:mm:ss');
      } else {
        lastCycleRunText = end.format('YYYY-MM-DD HH:mm:ss');
      }
    }

    return {
      firstOrNextText,
      isFutureStart,
      lastCycleRunText,
    };
  };

  const TaskRow = ({ task }) => {
    const execDetails = getExecutionDetails(task);

    return (
      <tr>
        <td className="font-weight-bold text-dark">{getTaskName(task, commandsMap)}</td>
        <td><span className="badge badge-light border">{formatTaskValue(task)}</span></td>
        <td><small className="text-muted">{parseDatetime(task.startAt) || '-'}</small></td>
        <td><small className="text-muted">{parseDatetime(task.endAt) || '-'}</small></td>
        <td>
          <span className="badge badge-info p-2">
            Co {task.reccuringEvery} sek.
          </span>
          {execDetails && (
            <div className="mt-1 small">
              {execDetails.firstOrNextText && (
                <div className="text-muted">
                  {execDetails.isFutureStart ? "Pierwsze wykonanie: " : "Najbliższe wykonanie: "}
                  <strong className="text-dark">{execDetails.firstOrNextText}</strong> <small className="text-muted">(± 15 min. komunikacji)</small>
                </div>
              )}
              {execDetails.lastCycleRunText && (
                <div className="text-muted mt-1">
                  Ostatnie wykonanie: <strong className="text-dark">{execDetails.lastCycleRunText}</strong>
                </div>
              )}
            </div>
          )}
        </td>
        <td><small className="text-muted">{parseDatetime(task.createDateTime)}</small></td>
        <td><small className="text-muted">{parseDatetime(task.lastStartDateTime) || '-'}</small></td>
        <td className="text-right">
          <button
            className='btn btn-sm btn-outline-danger'
            onClick={() => cancelTask(task.machineTaskId)}
            title="Usuń zadanie cykliczne"
          >
            Usuń
          </button>
        </td>
      </tr>
    );
  };

  const activeTasks = tasks.filter(task => task.status !== 4);

  return (
    <div className='card w-100 shadow-sm border-0 mb-4'>
      <div className='card-header bg-white py-3 d-flex justify-content-between align-items-center border-bottom'>
        <h5 className="m-0 font-weight-bold text-dark">
          Aktywne zadania cykliczne VMC ({activeTasks.length})
        </h5>
      </div>
      <div className='card-body p-0'>
        <div className="table-responsive">
          <table className='table table-hover align-middle mb-0'>
            <thead className="thead-light">
              <tr>
                <th>Zadanie</th>
                <th>Wartość</th>
                <th>Start</th>
                <th>Koniec</th>
                <th>Częstotliwość</th>
                <th>Stworzone</th>
                <th>Ostatnie wykonanie</th>
                <th className="text-right">Akcja</th>
              </tr>
            </thead>
            <tbody>
              {activeTasks.length > 0 ? (
                activeTasks.map(task => (
                  <TaskRow key={task.machineTaskId} task={task} />
                ))
              ) : (
                <tr>
                  <td colSpan={8} className="text-center py-4 text-muted">
                    Brak skonfigurowanych zadań cyklicznych.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
